import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SectionHead, Reveal } from "@/components/Reveal";
import { EnquiryForm } from "@/components/EnquiryForm";
import { BRAND } from "@/data/content";

export default function Consult() {
    return (
        <section id="consult" className="relative border-t border-white/10 bg-void py-28 md:py-36" data-testid="consult-section">
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <SectionHead
                            number="10"
                            label="Start here"
                            title="See what HIGHTS could build for you."
                        />
                        <Reveal delay={0.2}>
                            <p className="mt-8 max-w-md text-base font-light leading-relaxed text-white/60">
                                Book a free 10–20 minute consultation. We'll look at your current online presence,
                                understand your goals and show you where automation, AI, development and
                                optimisation could create opportunities.
                            </p>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <Link
                                to="/book"
                                data-testid="consult-book-button"
                                className="group mt-10 inline-flex items-center gap-3 bg-white px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-black transition-colors hover:bg-white/85"
                            >
                                Book my consultation
                                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </Link>
                        </Reveal>
                        <Reveal delay={0.4}>
                            <div className="mt-12 space-y-3 border-t border-white/10 pt-8 text-sm text-white/55">
                                <p>Prefer to talk first?</p>
                                <p><a href={`mailto:${BRAND.email}`} className="text-white underline-offset-4 transition-colors hover:text-white/70 hover:underline" data-testid="consult-email">{BRAND.email}</a></p>
                                <p><a href={`https://wa.me/${BRAND.phoneIntl}?text=${encodeURIComponent(BRAND.whatsappMsg)}`} target="_blank" rel="noopener noreferrer" className="text-white underline-offset-4 transition-colors hover:text-white/70 hover:underline" data-testid="consult-whatsapp">WhatsApp — {BRAND.phoneDisplay}</a></p>
                            </div>
                        </Reveal>
                    </div>
                    <Reveal delay={0.15} className="lg:col-span-7">
                        <div className="border border-white/12 bg-surface p-7 md:p-10">
                            <p className="mb-8 font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
                                Or send an enquiry — it lands directly in the HIGHTS CRM
                            </p>
                            <EnquiryForm source="website" />
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
